import { actionHandlerWithFeatureFlag } from 'utils';
import { FEATURE_FLAGS } from 'utils/constants';
import {
  msGetCurrentSystemAnnouncement,
  msGetAllSystemAnnouncements,
  msGetAllSystemAnnouncementTargets,
  msGetCurrentSystemAnnouncementByTarget,
  msUpdateSystemAnnouncement,
  msDeleteSystemAnnouncement,
  msAddNewSystemAnnouncement,
  msEndSystemAnnouncement,
} from 'services/SystemAnnouncementService';
import { SkApolloRequest } from '../../utils/apolloUtils';
import {
  ADD_NEW_SYSTEM_ANNOUNCEMENT_V2,
  GET_ALL_SYSTEM_ANNOUNCEMENTS,
  UPDATE_SYSTEM_ANNOUNCEMENT_V2,
  DELETE_SYSTEM_ANNOUNCEMENT,
  GET_CURRENT_SYSTEM_ANNOUNCEMENT_V2,
  GET_ALL_SYSTEM_ANNOUNCEMENT_TARGETS,
  GET_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET,
  END_SYSTEM_ANNOUNCEMENT,
} from '../models/systemAnnouncementModel';
import {
  FETCH_SYSTEM_ANNOUNCEMENTS_LOADING,
  FETCH_SYSTEM_ANNOUNCEMENTS_SUCCESS,
  FETCH_SYSTEM_ANNOUNCEMENTS_ERROR,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_LOADING,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_SUCCESS,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_ERROR,
  FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_LOADING,
  FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_SUCCESS,
  FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_ERROR,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_LOADING,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_SUCCESS,
  FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_ERROR,
  SET_ALERT,
} from './actionTypes';
import DatadogHandler from '../../utils/datadog';

const systemAnnouncementsLoading = () => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_LOADING,
  key: 'allSystemAnnouncements',
  value: {
    inProgress: true,
  },
});

const systemAnnouncementsSuccess = data => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_SUCCESS,
  key: 'allSystemAnnouncements',
  value: {
    inProgress: false,
    data,
  },
});

const systemAnnouncementsError = error => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_ERROR,
  key: 'allSystemAnnouncements',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const currentSystemAnnouncementLoading = () => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_LOADING,
  key: 'currentSystemAnnouncement',
  value: {
    inProgress: true,
  },
});

const currentSystemAnnouncementSuccess = data => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_SUCCESS,
  key: 'currentSystemAnnouncement',
  value: {
    inProgress: false,
    data,
  },
});

const currentSystemAnnouncementError = error => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_ERROR,
  key: 'currentSystemAnnouncement',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const currentSystemAnnouncementByTargetLoading = () => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_LOADING,
  key: 'currentSystemAnnouncementByTarget',
  value: {
    inProgress: true,
  },
});

const currentSystemAnnouncementByTargetSuccess = data => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_SUCCESS,
  key: 'currentSystemAnnouncementByTarget',
  value: {
    inProgress: false,
    data,
  },
});

const currentSystemAnnouncementByTargetError = error => ({
  type: FETCH_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET_ERROR,
  key: 'currentSystemAnnouncementByTarget',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

const systemAnnouncementTargetsLoading = () => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_LOADING,
  key: 'systemAnnouncementTargets',
  value: {
    inProgress: true,
  },
});

const systemAnnouncementTargetsSuccess = data => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_SUCCESS,
  key: 'systemAnnouncementTargets',
  value: {
    inProgress: false,
    data,
  },
});

const systemAnnouncementTargetsError = error => ({
  type: FETCH_SYSTEM_ANNOUNCEMENTS_TARGETS_ERROR,
  key: 'systemAnnouncementTargets',
  value: {
    inProgress: false,
    data: null,
    error,
  },
});

export const monoAddNewSystemAnnouncement = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: ADD_NEW_SYSTEM_ANNOUNCEMENT_V2,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.sendLog(ex.message, {}, 'error');
    return ex;
  }
};

export const addNewSystemAnnouncement = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msAddNewSystemAnnouncement,
    monoHandler: monoAddNewSystemAnnouncement,
    extraData: reqData,
  });

export const monoUpdateSystemAnnouncement = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: UPDATE_SYSTEM_ANNOUNCEMENT_V2,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.sendLog(ex.message, {}, 'error');
    return ex;
  }
};

export const updateSystemAnnouncement = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msUpdateSystemAnnouncement,
    monoHandler: monoUpdateSystemAnnouncement,
    extraData: reqData,
  });

export const monoDeleteSystemAnnouncement = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: DELETE_SYSTEM_ANNOUNCEMENT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.sendLog(ex.message, {}, 'error');
    return ex;
  }
};

export const deleteSystemAnnouncement = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msDeleteSystemAnnouncement,
    monoHandler: monoDeleteSystemAnnouncement,
    extraData: reqData,
  });

export const monoEndSystemAnnouncement = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        mutation: END_SYSTEM_ANNOUNCEMENT,
        variables: reqData,
      },
      type: 'mutation',
    });
    return data;
  } catch (ex) {
    DatadogHandler.sendLog(ex.message, {}, 'error');
    return ex;
  }
};

export const endSystemAnnouncement = reqData => async () =>
  actionHandlerWithFeatureFlag(FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED, {
    msHandler: msEndSystemAnnouncement,
    monoHandler: monoEndSystemAnnouncement,
    extraData: reqData,
  });

export const monoGetAllSystemAnnouncements = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ALL_SYSTEM_ANNOUNCEMENTS,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return ex;
  }
};

export const getAllSystemAnnouncements = reqData => async dispatch => {
  dispatch(systemAnnouncementsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllSystemAnnouncements,
        monoHandler: monoGetAllSystemAnnouncements,
        extraData: reqData,
      }
    );
    if (data.success) {
      dispatch(systemAnnouncementsSuccess(data.data));
    } else {
      dispatch(systemAnnouncementsError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(systemAnnouncementsError(ex.message));
    return ex;
  }
};

export const monoGetCurrentSystemAnnouncement = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CURRENT_SYSTEM_ANNOUNCEMENT_V2,
        variables: reqData,
      },
      type: 'query',
    });

    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(
      ex,
      {
        functionName: 'monoGetCurrentSystemAnnouncement',
        fileName: 'redux/actions/SystemAnnouncement.js',
      },
      'error'
    );
    return {
      success: false,
      error: ex.message,
    };
  }
};

export const getCurrentSystemAnnouncement = reqData => async dispatch => {
  dispatch(currentSystemAnnouncementLoading());
  const data = await actionHandlerWithFeatureFlag(
    FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
    {
      dispatch,
      msHandler: msGetCurrentSystemAnnouncement,
      monoHandler: monoGetCurrentSystemAnnouncement,
      extraData: reqData,
    }
  );

  if (data.success) {
    dispatch(currentSystemAnnouncementSuccess(data.data));
  } else {
    dispatch(currentSystemAnnouncementError(data.error));
  }
  return data;
};

export const monoGetAllSystemAnnouncementTargets = async dispatch => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_ALL_SYSTEM_ANNOUNCEMENT_TARGETS,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    dispatch(systemAnnouncementTargetsError(ex.message));
    return ex;
  }
};

export const getAllSystemAnnouncementTargets = () => async dispatch => {
  dispatch(systemAnnouncementTargetsLoading());
  try {
    const data = await actionHandlerWithFeatureFlag(
      FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
      {
        dispatch,
        msHandler: msGetAllSystemAnnouncementTargets,
        monoHandler: monoGetAllSystemAnnouncementTargets,
      }
    );
    if (data.success) {
      dispatch(systemAnnouncementTargetsSuccess(data.data));
    } else {
      dispatch(systemAnnouncementTargetsError(data.error));
    }
    return data;
  } catch (ex) {
    dispatch(systemAnnouncementTargetsError(ex.message));
    return ex;
  }
};

export const monoGetCurrentSystemAnnouncementByTarget = async (_, reqData) => {
  try {
    const data = await SkApolloRequest({
      params: {
        query: GET_CURRENT_SYSTEM_ANNOUNCEMENT_BY_TARGET,
        variables: reqData,
      },
      type: 'query',
    });
    return data;
  } catch (ex) {
    DatadogHandler.addError(ex);
    DatadogHandler.sendLog(ex, {}, 'error');
    return ex;
  }
};

export const getCurrentSystemAnnouncementByTarget =
  reqData => async dispatch => {
    dispatch(currentSystemAnnouncementByTargetLoading());
    try {
      const data = await actionHandlerWithFeatureFlag(
        FEATURE_FLAGS.MS_PHASE_3_PORTAL_DISABLED,
        {
          dispatch,
          msHandler: msGetCurrentSystemAnnouncementByTarget,
          monoHandler: monoGetCurrentSystemAnnouncementByTarget,
          extraData: reqData,
        }
      );
      if (data.success) {
        dispatch(currentSystemAnnouncementByTargetSuccess(data.data));
      } else {
        dispatch(currentSystemAnnouncementByTargetError(data.error));
      }
      return data;
    } catch (ex) {
      dispatch(currentSystemAnnouncementByTargetError(ex.message));
      return ex;
    }
  };

export const setAnnouncementAlert = value => ({
  type: SET_ALERT,
  value,
});
